import { z } from 'zod';
import type { API } from '../types/res.api';

export const devResetAPISchema = z.object({});

export type DevResetAPI = API<z.infer<typeof devResetAPISchema>, { success: boolean }>;
